export default __webpack_public_path__ + "static/media/logo1.ceeb58b0.png";